import React, { useState } from "react";
import Back from "assets/left.svg";
import * as S from "./styles";
import Logo from "assets/logotipo.svg";
import Input from "components/Input";
import { pinVerifyService, sendPinService } from "services/PinService";
import { forgetPasswordService } from "services/UserServices";
import { useHistory } from "react-router-dom";
import Button from "components/Button";
import { getTenantByCode } from "services/TenantServices";

export function ForgetPassword() {
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [password, setPassword] = useState("");
  const [sended, setSended] = useState(false);
  const [verify, setVerify] = useState(false);
  const location = useHistory();
  const [invalidEmail, setInvalidEmail] = useState(false);
  const [tenantCode, setTenantCode] = useState<string>();
  const [invalidTenantCodeError, setInvalidTenantCodeError] =
    useState<string>();

  async function handleSubmit(event: React.SyntheticEvent) {
    event.preventDefault();
    setInvalidTenantCodeError(undefined);
    const { item } = await getTenantByCode(tenantCode || "");

    if (!item) {
      setInvalidTenantCodeError("O código da empresa especificado é invalido!");
    }

    sendPinService({ email, token: item.token })
      .then((response) => {
        setSended(true);
      })
      .catch((err) => {
        console.error(err.response);
        setInvalidEmail(true);
      });
  }

  function handleCodeSubmit(event: React.SyntheticEvent) {
    event.preventDefault();
    pinVerifyService({ email, code })
      .then((response) => {
        setVerify(true);
      })
      .catch((err) => {
        console.error(err.response);
      });
  }

  function handleChangePasswordSubmit(event: React.SyntheticEvent) {
    event.preventDefault();

    forgetPasswordService({ email, password })
      .then((response) => {
        location.push("/");
      })
      .catch((err) => {
        console.error(err.response);
      });
  }

  return (
    <S.Container>
      <S.ContentContainer>
        <S.TextContainer>
          <img src={Logo} alt={"logo"} />
          <h1>Soluções rápidas e efetivas na área de segurança.</h1>
          <p>
            Atendimento de qualidade e excelência 24 horas por dia, 7 dias por
            semana.
          </p>
        </S.TextContainer>
      </S.ContentContainer>

      {verify ? (
        <S.ForgetPasswordForm
          onSubmit={(event: React.SyntheticEvent) =>
            handleChangePasswordSubmit(event)
          }
        >
          <div>
            <S.BackButton
              onClick={() => {
                setVerify(false);
                setSended(true);
              }}
            >
              <img src={Back} alt={"icone do botao voltar"} />
              <p>Voltar</p>
            </S.BackButton>
            <h2>Nova senha</h2>
            <p>Insira a nova senha.</p>
            <Input
              id="password"
              name="password"
              type="password"
              label="Nova senha"
              required={true}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setPassword(event.target.value);
              }}
            />
            <Button title="Enviar" type="submit" />
          </div>
        </S.ForgetPasswordForm>
      ) : sended ? (
        <S.ForgetPasswordForm
          onSubmit={(event: React.SyntheticEvent) => handleCodeSubmit(event)}
        >
          <div>
            <S.BackButton
              onClick={() => {
                setSended(false);
              }}
            >
              <img src={Back} alt={"icone do botao voltar"} />
              <p>Voltar</p>
            </S.BackButton>
            <h2>Envie o Código</h2>
            <p>Insira seu codigo que foi enviado ao seu e-mail.</p>
            <Input
              id="code"
              name="code"
              type="code"
              label="Código"
              required={true}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setCode(event.target.value);
              }}
            />
            <Button title="Enviar" type="submit" />
          </div>
        </S.ForgetPasswordForm>
      ) : (
        <S.ForgetPasswordForm
          onSubmit={(event: React.SyntheticEvent) => handleSubmit(event)}
        >
          <div>
            <S.BackButton
              onClick={() => {
                location.push("/");
              }}
            >
              <img src={Back} alt={"icone do botao voltar"} />
              <p>Voltar</p>
            </S.BackButton>
            <h2>Esqueceu sua senha?</h2>
            <p>
              Insira seu e-mail cadastrado na plataforma para enviarmos uma
              recuperação.
            </p>
            <Input
              id="email"
              name="email"
              type="email"
              label="E-mail"
              error={invalidEmail}
              required={true}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setEmail(event.target.value);
              }}
            />
            <Input
              id="tenant_code"
              name="tenant_code"
              type="text"
              label="Código da empresa"
              required={true}
              error={invalidTenantCodeError}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setTenantCode(event.target.value);
              }}
            />
            <Button title="Enviar" type="submit" />
          </div>
        </S.ForgetPasswordForm>
      )}
    </S.Container>
  );
}
